import { render, staticRenderFns } from "./ProjectSubTasks.vue?vue&type=template&id=09659623&"
import script from "./ProjectSubTasks.vue?vue&type=script&lang=js&"
export * from "./ProjectSubTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectSubTasks.vue"
export default component.exports